import React from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'

import { Box, Tabs } from '@factorialco/deprecated-design-system'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import {
  getNavigationForTypeFromFunction,
  getNodeTypeFromParams,
  isNodeType,
  nodeTypeChildren,
} from 'modules/job_catalog/lib/nodesUtils'

export function NodeTabs() {
  const location = useLocation()
  const { navigation } = useNavigation()
  const navigate = useNavigate()
  const { rootId, familyId, functionId, roleId, levelId } = useParams()

  const params: {
    rootId: string
    familyId: string
    functionId?: string
    roleId?: string
    levelId?: string
  } = {
    rootId: rootId || '',
    familyId: familyId || '',
    ...(functionId && { functionId }),
    ...(roleId && { roleId }),
    ...(levelId && { levelId }),
  }

  const type = getNodeTypeFromParams({ familyId, functionId, roleId, levelId })
  const nodeLabel = isNodeType(type) ? nodeTypeChildren(type) : type
  const nav = getNavigationForTypeFromFunction(navigation, type)

  const navParams = {
    rootId: params.rootId,
    familyId: params.familyId,
    functionId: params.functionId || '',
    roleId: params.roleId || '',
    levelId: params.levelId || '',
  }
  const tabs = [
    ...(!levelId
      ? [
          {
            id: nav.fullPath(navParams),
            label: nodeLabel,
          },
        ]
      : []),
    /*{
      id: levelId ? nav.fullPath(navParams) : nav.workingConditions.fullPath(navParams),
      label: i18n.t('job_catalog.nodes.work_conditions')
    },*/
    {
      id: nav.competencies.fullPath(navParams),
      label: i18n.t('job_catalog.nodes.competency.multiple'),
    },
  ]

  return (
    <Box position="relative" width="full">
      <Tabs currentId={location.pathname} onTabClicked={(to: string) => navigate(to)}>
        {tabs.map(({ id, label }) => (
          <Tabs.Tab key={id} id={id} label={label} />
        ))}
      </Tabs>
    </Box>
  )
}
